const cmsToCFS = 35.314666212661;

const metersToFeet = 3.28048;

//const apiURL = 'http://localhost:5000/fcast';
const apiURL = 'https://api.floodcast.dewberryanalytics.com/fcast';
const vectorTileServer = `${apiURL}/tile_serv`;

const pad = (num, size) => {
  num = num.toString();
  while (num.length < size) num = '0' + num;
  return num;
};

const config = {
  apiURL: apiURL,
  forecastURL: `${apiURL}/forecast`,
  triggerLevelURL: `${apiURL}/asset`,
  featureServer: `${apiURL}/feature_serv`,
  usaStatesURL: `${apiURL}/states`,
  cogTileServURL: `${apiURL}/cog_tileserv`,

  unitConversionsValues: {
    cmsToCFS: cmsToCFS,
    metersToFeet: metersToFeet
  },

  stateAssetsTileService: (state, assetForecastTable) => {
    return `${vectorTileServer}/${state}.${assetForecastTable}/{z}/{x}/{y}.pbf?properties=`;
  },

  stateAssetsTileServiceWithSelect: (state, assetForecastTable, assetID) => {
    return `${vectorTileServer}/${state}.${assetForecastTable}/{z}/{x}/{y}.pbf?asset_id=${assetID}`;
  },

  convertCMStoCFS: (cmsVal) => {
    return cmsVal * cmsToCFS;
  },

  convertCFStoCMS: (cfsVal) => {
    return cfsVal / cmsToCFS;
  },

  convertMetersToFeet: (metersVal) => {
    return metersVal * metersToFeet;
  },

  convertFeetToMeters: (feetVal) => {
    return feetVal / metersToFeet;
  },

  formatDateTime: (datetime) => {
    const dt = new Date(datetime);
    const dtStr = dt.toString();
    return dtStr.slice(0, 18);
  },

  localeTZShortCode: () => {
    return new Date()
      .toLocaleDateString('en-US', { day: '2-digit', timeZoneName: 'short' })
      .slice(4);
  },

  getPGPubtimeStrUTC: (forecastPubTime) => {
    const year = forecastPubTime.getUTCFullYear();
    const month = pad(forecastPubTime.getUTCMonth() + 1, 2);
    const date = pad(forecastPubTime.getUTCDate(), 2);
    const hour = pad(forecastPubTime.getUTCHours(), 2);
    const minute = pad(forecastPubTime.getUTCMinutes(), 2);
    return `${year}-${month}-${date} ${hour}:${minute}:00 UTC`;
  },

  darkPlotColors: {
    colorMajor: '#cc33ff', // official AHPS colors
    colorModerate: '#ff0000', // official AHPS colors
    colorMinor: '#ff9900', // official AHPS colors
    colorAction: '#ffff00', // official AHPS colors
    colorNominal: '#00ff00', //official AHPS colors
    colorGround: 'white',
    colorWSEMedium: '#87CEEB', //skyblue
    colorWSEShort: '#0096FF',
    colorGrid: 'darkgray',
    colorAxis: 'darkgray'
  },
  lightPlotColors: {
    colorMajor: '#cc33ff', // official AHPS colors
    colorModerate: '#ff0000', // official AHPS colors
    colorMinor: '#ff9900', // official AHPS colors
    colorAction: '#d8d800',
    colorNominal: '#00ff00', //official AHPS colors
    colorGround: 'black',
    colorWSEMedium: '#87CEEB', //skyblue
    colorWSEShort: '#0096FF',
    colorGrid: 'black',
    colorAxis: 'black'
  },

  conusBounds: [
    [-127, 20],
    [-65, 49]
  ]
};

export default config;
